
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import './pendo-button.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import './pendo-tooltip.js';
import './pendo-divider.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import './picker-popover-mixin.js';
import 'lodash/debounce';
import './emitter-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import PendoModal from './pendo-modal.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import './pendo-multiselect.js';
import 'lodash/cloneDeep';
import '@shopify/draggable/lib/es5/sortable.js';
import './pendo-draggable.js';
import PendoColumnReorder from './pendo-column-reorder.js';

var script = {
  name: 'PendoColumnChooser',
  components: {
    PendoModal,
    PendoColumnReorder
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    },
    availableColumns: {
      type: Array,
      default: () => []
    },
    disableFirst: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    valueKey: {
      type: String,
      default: 'prop'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    placeholder: {
      type: String
    },
    title: {
      type: String,
      default: 'Manage Columns'
    },
    description: {
      type: String,
      default: 'Add, reorder or remove columns to customize your table.'
    },
    addButtonLabel: {
      type: String
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    confirmButtonConfig: {
      type: Object,
      default: () => ({
        label: 'Save'
      })
    },
    cancelButtonConfig: {
      type: Object,
      default: () => ({
        label: 'Cancel'
      })
    },
    allSelectedText: {
      type: String
    }
  },

  data() {
    return {
      model: [],
      allColumnsSelected: false
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.visible;
      },

      set(val) {
        this.$emit('update:visible', val);

        if (val) {
          this.$emit('open');
        } else {
          this.$emit('close');
        }
      }

    }
  },
  methods: {
    initialize() {
      this.model = [...new Set([...this.columns])];
      this.updateScroll();
    },

    handleConfirm() {
      this.$emit('confirm', this.model.filter(column => Object.keys(column).length));
      this.isVisible = false;
    },

    handleCancel() {
      this.$emit('cancel');
      this.isVisible = false;
    },

    updateScroll() {
      this.$nextTick(() => {
        const modalBody = document.querySelector('.el-dialog__body');

        if (modalBody) {
          modalBody.scrollTop = modalBody.scrollHeight - modalBody.clientHeight;
        }
      });
    },

    updateColumns(value) {
      this.model = value;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-column-chooser"
  }, [_c('pendo-modal', {
    attrs: {
      "title": _vm.title,
      "height": "auto",
      "max-height": "85%",
      "append-to-body": _vm.appendToBody,
      "visible": _vm.isVisible,
      "confirm-button-config": _vm.confirmButtonConfig,
      "cancel-button-config": _vm.cancelButtonConfig
    },
    on: {
      "update:visible": function ($event) {
        _vm.isVisible = $event;
      },
      "open": _vm.initialize,
      "confirm": _vm.handleConfirm,
      "cancel": _vm.handleCancel
    }
  }, [!!_vm.$slots.before ? _c('div', {
    staticClass: "pendo-column-chooser__before"
  }, [_vm._t("before")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pendo-column-chooser__description"
  }, [_vm._v("\n            " + _vm._s(_vm.description) + "\n        ")]), _vm._v(" "), _c('pendo-column-reorder', {
    attrs: {
      "value": _vm.model,
      "available-columns": _vm.availableColumns,
      "disable-first": _vm.disableFirst,
      "disabled": _vm.disabled,
      "value-key": _vm.valueKey,
      "label-key": _vm.labelKey,
      "placeholder": _vm.placeholder,
      "add-button-label": _vm.addButtonLabel,
      "all-selected-text": _vm.allSelectedText
    },
    on: {
      "columns-change": _vm.updateColumns
    },
    scopedSlots: _vm._u([_vm.$slots.multiselect || _vm.$scopedSlots.multiselect ? {
      key: "multiselect",
      fn: function (props) {
        return [_vm._t("multiselect", null, null, props)];
      }
    } : null], null, true)
  }), _vm._v(" "), _vm.$slots.footer || _vm.$scopedSlots.footer ? _c('template', {
    slot: "footer"
  }, [_vm._t("footer", null, {
    "model": _vm.model,
    "confirm": _vm.handleConfirm,
    "cancel": _vm.handleCancel
  })], 2) : _vm._e()], 2)], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-column-chooser.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoColumnChooser = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoColumnChooser;
